import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from 'src/features';
import { getResortUserColor } from 'src/lib/getResortUserColor';
import { ConstructionDetailContent } from './ConstructionDetailContent';

export const ConstructionMyDetail: React.FC = () => {
  const { displayedUserProfile } = useSelector((state: RootState) => state.resort);
  const { id } = useParams<{ id: string }>();

  if (displayedUserProfile?.state !== 'ok' || id === undefined) {
    return <></>;
  }

  const profile = displayedUserProfile.result;

  const found = profile.constructions.find(item => item.resortId === id);
  if (!found) {
    return <></>;
  }

  const { resortPlannerPromotionColor, resortPlannerPromotionDeco } = profile;
  const userColor = getResortUserColor(resortPlannerPromotionColor);

  return (
    <ConstructionDetailContent
      isMyConstruction={true}
      construction={found}
      userColor={userColor}
      decoId={resortPlannerPromotionDeco}
    />
  );
};
